import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import  {getLens } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";



function DatatableTables({ refresh }) {
  const [lenses, setLenses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllLenses();
  }, [refresh]);

  const getAllLenses = async () => {
    try {
      const response = await getLens();
      if (Array.isArray(response?.data?.data)) {
        setLenses(response.data.data);
      } else {
        toast.error("Failed to fetch lens data");
        setLenses([]);
      }
    } catch (error) {
      toast.error("Error fetching lenses");
      console.error(error);
    }
  };


   const columns = useMemo(
    () => [
      {
        Header: "Lens Title",
        accessor: "lens_title",
      },
      {
        Header: "Vision Name",
        accessor: "lens_vision_name",
      },
      {
        Header: "Sub Vision Name",
        accessor: "lens_subvision_name",
      },
      {
        Header: "Material",
        accessor: "lens_material",
      },
      // Add more columns if needed
    ],
    []
  );
    //meta title
    document.title = "Lens | List";

    return (
        <div className="page-content">
            <div className="container-fluid ">
            <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/addlens" className="btn btn-primary">ADD NEW LENS</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Lens" />
                <TableContainer
                        columns={columns}
                        data={lenses}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        {/* <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this region?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal> */}
            </div>
       </div>
    );
}

export default DatatableTables;